goog.provide('el8.practicedata.incomingFileGroups');

goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.practicedata.uploadedImages');
goog.require('el8.practicedata.uploadedFiles');
goog.require('el8.data.referencedUsers');


el8.practicedata.incomingFileGroups = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.images) {
            spec.image_ids = spec.images.map(function(f) {
                f['incoming_file_group_id'] = spec.id;
                var a = el8.practicedata.uploadedImages.create(f);
                return a.getId();
            });
        }
        if (spec.files) {
            spec.file_ids = spec.files.map(function(f) {
                f['incoming_file_group_id'] = spec.id;
                var a = el8.practicedata.uploadedFiles.create(f);
                return a.getId();
            });
        }
        this.parent.populate.call(this, spec);
    };

    _class.addStringProperty('fromNumber');
    _class.addDateTime('receivedTime');
    _class.addStringProperty('processState');
    _class.addIntProperty('practiceFaxId');

    _class.addProperty('fileIds', []);
    _class.addProperty('imageIds', []);
    _class.addStringProperty('originalFilename');

    _class.addStringProperty('source');
    _class.addIntProperty('userId');
    _class.addBoolean('rasterizable');

    _class.prototype.hasImages = function() {
        // Whether this has rasterized images or non-rasterizable files
        // Important flag for deciding what to do with a filegroup
        return !this.getFileIds().length;
    };

    _class.prototype.removeImageId = function(imageId) {
        var oldImageIds = this.getImageIds();
        var newImageIds = [];
        var removed = false;
        for (var i=0; i<oldImageIds.length; i++) {
            if (oldImageIds[i] !== imageId) {
                newImageIds.push(oldImageIds[i]);
            } else {
                removed = true;
            }
        }
        this.setImageIds(newImageIds);
        return removed;
    };

    _class.prototype.removeFileId = function(fileId) {
        var oldFileIds = this.getFileIds();
        var newFileIds = [];
        var removed = false;
        for (var i=0; i<oldFileIds.length; i++) {
            if (oldFileIds[i] !== fileId) {
                newFileIds.push(oldFileIds[i]);
            } else {
                removed = true;
            }
        }
        this.setFileIds(newFileIds);
        return removed;
    };

    _class.prototype.getFileCount = function() {
        return this.hasImages() ? this.getImageIds().length : this.getFileIds().length;
    };

    _class.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);

        m['userFullName'] = '';
        if (this.getUserId()) {
            var user = el8.data.referencedUsers.getById(this.getUserId());
            m['userFullName'] = user.getFullName();
        }

        m['fileCount'] = this.getFileCount();

        return m;
    };

    _class.prototype.getFileFeedIndex = function() {
        if (this.hasImages()) {
            return this.getImageIds().map(function(id) {
                var file = el8.practicedata.uploadedImages.getById(id);
                return file ? {
                    id: file.getId(),
                    model_class: file.getModelClass(),
                    feed_date: file.getReceivedDate()
                } : null;
            }).filter(function(a) { return a !== null; });
        } else {
            return this.getFileIds().map(function(id) {
                var file = el8.practicedata.uploadedFiles.getById(id);
                return file ? {
                    id: file.getId(),
                    model_class: file.getModelClass(),
                    feed_date: file.getReceivedDate()
                } : null;
            }).filter(function(a) { return a !== null; });
        }
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { return el8.service.urls.get('fileGroup', [id]); },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('fileGroup', [item.getId()]),
                async: opts.async,
                success: successCb,
                error: errorCb
            });
        }
    });

    return that;

})();


